import Vue from 'vue'
import Vuex from 'vuex'
import { isMideaConnect, browserAgent, requestByMethod, getUUID, request } from '../utils/utils'
import PROJECT_CONFIG from '../project_config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    article: {},
    articleTitle: '',
    commentNumber: 0,
    userId: '',
    token: null,
    noTokenFlag: false,
    scrollTop: -1,
    formList: [],
    headImgUrl: PROJECT_CONFIG.methods.headImgUrl,
    contentWidth: 0, // 内容宽度
    showLoadingPic: true,
    thumbnailFullFlag: false, // 是否预览帖子图片
    closeGallery: false
  },
  getters: {
    article: state => state.article,
    commentNumber: state => state.commentNumber,
    userId: state => state.userId,
    token: state => state.token,
    noTokenFlag: state => state.noTokenFlag,
    articleTitle: state => state.articleTitle,
    scrollTop: state => state.scrollTop,
    scrollHeight: state => state.scrollHeight,
    headImgUrl: state => state.headImgUrl,
    contentWidth: state => state.contentWidth,
    showLoadingPic: state => state.showLoadingPic,
    thumbnailFullFlag: state => state.thumbnailFullFlag,
    closeGallery: state => state.closeGallery
  },
  mutations: {
    'SET_THUMBNAIL_FULL_FLAG' (state, data) {
      state.thumbnailFullFlag = data
    },
    'SET_CLOSE_GALLERY' (state, data) {
      state.closeGallery = data
    },
    articleStatus (state, payload) {
      state.article = payload.article
    },
    setFormList (state, data) {
      state.formList = data
    },
    articleTitleStatus (state, payload) {
      state.articleTitle = payload.articleTitle
    },
    userIdStatus (state, payload) {
      state.userId = payload.userId
    },
    tokenStatus (state, payload) {
      state.token = payload.token
    },
    noTokenFlagStatus (state, payload) {
      state.noTokenFlag = payload.noTokenFlag
    },
    commentNumberStatus (state, payload) {
      state.commentNumber = payload.commentNum
    },
    increaseCommentNum (state) {
      ++state.commentNumber
    },
    scrollTopStatus (state, payload) {
      state.scrollTop = payload.scrollTop
    },
    contentWidthStatus (state, payload) {
      state.contentWidth = payload.contentWidth
    },
    showLoadingPicStatus (state, payload) {
      state.showLoadingPic = payload.showLoadingPic
    }
    // scrollHeightStatus (state, payload) {
    //   state.scrollHeight = payload.scrollHeight
    // }
  },
  actions: {
    /**
     * 查看MXP文章详细
     * appkey  底座从map获取
     * accessToken accessToken  底座从map获取
     * sid 服务号id
     * pid 推送id
     * articelId   文章id
     * articleId, isThird, userId, userName
     */
    getArticleDetailMXP (context, payload) {
      return new Promise((resolve) => {
        if (window.location.href.indexOf('type=h5') > -1) {
          payload.ssoToken = sessionStorage.getItem('token')
        }
        if (!payload.appKey) {
          if (Vue.prototype.$baseUrl.indexOf('sit') > -1) {
            payload.appKey = PROJECT_CONFIG.base_appkey.base_appkey_test
          } else {
            payload.appKey = PROJECT_CONFIG.base_appkey.base_appkey_pro
          }
        }
        const params = {
          isThirdPartPlat: payload.isThirdPartPlat,
          userId: payload.userId ? payload.userId : getUUID(32, 16),
          userName: payload.username ? payload.username : '匿名用户',
          articelId: payload.articleId,
          appKey: payload.appKey,
          sid: payload.sid,
          accessToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
          mipToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? payload.ssoToken : null) : null,
          lang: 'zh'
          // pid: BASE.response.pushId // todo: 暂时删除
        }
        resolve(request(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.getArticleDetailMxp, params, {
          method: 'jsonp'
        }))
      })
    },
    /**
     * MXP图文推送文章查看文章评论列表&查看评论的评论列表
     * @param articleId 文章ID
     * articleId, pageNum, targetType, isThird, userId
     */
    queryCommentListMxp (context, payload) {
      return new Promise((resolve) => {
        if (window.location.href.indexOf('type=h5') > -1 && isMideaConnect()) {
          payload.ssoToken = sessionStorage.getItem('token')
        }
        const params = {
          isThirdPartPlat: payload.isThirdPartPlat,
          userId: payload.userId ? payload.userId : getUUID(32, 16),
          target_id: payload.articleId, // 文章ID
          pageNum: payload.pageNum, // 页码
          accessToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
          mipToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? payload.ssoToken : null) : null,
          target_type: payload.targetType // 评论对象的类型：1 表示文章的评论列表 、 2 表示评论的评论列表
        }
        resolve(request(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.queryCommentListMxp, params, {
          method: 'jsonp'
        }))
      })
    },
    /**
     * MXP图文推送文章发表评论——第三方平台
     * @param articleId
     * @param userId
     * @param userName
     * @param content
     * @param isHideName
     * @param targetType
     * articleId, userId, userName, content, targetType
     */
    createCommentMxpOther (context, payload) {
      if (window.location.href.indexOf('type=h5') > -1 && isMideaConnect()) {
        payload.ssoToken = sessionStorage.getItem('token')
      }
      const params = {
        // pid: BASE.response.pushId,
        accessToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
        mipToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
        isThirdPartPlat: payload.isThirdPartPlat, // true
        target_id: payload.articleId, // 文章Id或者评论ID
        userId: payload.userId ? payload.userId : getUUID(32, 16), // 随机唯一性ID  uuid
        userName: payload.userName ? payload.userName : '匿名用户', // 用户名
        content: payload.content, // 评论内容
        isHideName: payload.isHideName, // 是否匿名： true 是 ， false 否
        target_type: payload.targetType // 评论对象类型可以取以下值： 1：表示文章 、2 ：表示对评论进行评论
      }
      return requestByMethod(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.createCommentMxpOther, params, {
        method: 'jsonp'
      })
    },
    /**
     * MXP图文推送文章点赞——第三方平台
     * @param articleId 文章ID
     * articleId, userId, userName, targetType
     */
    addLikeMxpOther (context, payload) {
      if (window.location.href.indexOf('type=h5') > -1 && isMideaConnect()) {
        payload.ssoToken = sessionStorage.getItem('token')
      }
      const params = {
        isThirdPartPlat: payload.isThirdPartPlat,
        userId: payload.isThirdPartPlat ? getUUID(32, 16) : '',
        userName: payload.isThirdPartPlat ? '匿名用户' : '',
        target_id: payload.articleId,
        target_type: payload.targetType,
        accessToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
        mipToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null
      }

      return requestByMethod(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.addLikeMxpOther, params, {
        method: 'jsonp'
      })
    },
    /**
     * MXP图文推送文章取消点赞——第三方
     * @param articleId 文章ID
     * articleId, targetType, userId
     */
    cancelLikeMxpOther (context, payload) {
      if (window.location.href.indexOf('type=h5') > -1 && isMideaConnect()) {
        payload.ssoToken = sessionStorage.getItem('token')
      }
      const params = {
        isThirdPartPlat: payload.isThirdPartPlat,
        target_id: payload.articleId,
        userId: payload.isThirdPartPlat ? getUUID(32, 16) : '',
        userName: payload.isThirdPartPlat ? '匿名用户' : '',
        target_type: payload.targetType,
        accessToken: isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null,
        mipToken: null// isMideaConnect() ? (browserAgent().indexOf('imip') > -1 ? null : payload.ssoToken) : null
      }
      return requestByMethod(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.cancelLikeMxp, params, {
        method: 'jsonp'
      })
    },
    // 获取article list by tag
    //
    getListByCategoryId (context, payload) {
      return requestByMethod(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.getListByCategoryId, payload)
    },
    /**
     * 资讯中心新增接口 -- 获取资讯详情
     * @param {*} context
     * @param {*} payload
     */
    getContentDetail (context, payload) {
      return new Promise((resolve) => {
        const params = {
          locale: payload.locale || 'zh_CN',
          id: payload.id,
          type: payload.type || ''
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.getContentDetail
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.getContentDetail
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 文章预览
     * @param {*} context
     * @param {*} payload
     */
    getContentPreview (context, payload) {
      const params = {
        id: payload.id
      }
      let url = ''
      if (process.env.NODE_ENV === 'development') {
        url = PROJECT_CONFIG.methods.previewContent
      } else {
        url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.previewContent
      }
      return requestByMethod(url, params, {
        method: 'get'
      })
    },
    /**
     * 资讯中心新增接口 -- 资讯评论列表
     * @param {*} context
     * @param {*} payload
     */
    getContentQueryCommentList (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.target_id, // 文章ID
          pageNum: payload.pageNum, // 页码
          pageSize: payload.pageSize,
          target_type: payload.targetType, // 评论对象的类型：1 表示文章的评论列表 、 2 表示评论的评论列表\
          isThirdPartPlat: payload.isThirdPartPlat,
          accessToken: payload.identification === 'admin' && payload.ssoToken,
          _: new Date().getTime()
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.getContentQueryCommentList
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.getContentQueryCommentList
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    getRichText (context, payload) {
      return requestByMethod(payload.contentUrl, null, {
        method: 'get'
      })
    },
    /**
     * 资讯中心新增接口 -- 检查用户是否已经点赞和收藏
     * @param {*} context
     * @param {*} payload
     */
    checkContentHasClicked (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.target_id,
          target_type: 'article',
          sourceType: payload.sourceType
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.checkHasClicked
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.checkHasClicked
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 创建评论
     * @param {*} context
     * @param {*} payload
     */
    contentCreateComment (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.articleId, // 文章Id或者评论ID
          content: payload.content, // 评论内容
          isHideName: payload.isHideName, // 是否匿名： true 是 ， false 否
          target_type: payload.targetType, // 评论对象类型可以取以下值： 1：表示文章 、2 ：表示对评论进行评论
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentCommentCreate
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentCommentCreate
        }
        resolve(request(url, params, {
          method: 'post',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
        // 调试创建时可以使用下列代码，生产就不用了
        // if (process.env.NODE_ENV === 'development') {
        //   resolve(requestByMethod(url, params, {
        //     method: 'post',
        //     headers: { accessToken: payload.identification === 'admin' ? payload.ssoToken : undefined, appKey: payload.appKey }
        //   }))
        // } else {
        //   reject(new Error('第三方平台不允许评论'))
        // }
      })
    },
    /**
     * 资讯中心新增接口 -- 已读接口
     * @param {*} context
     * @param {*} payload
     */
    contentReadAdd (context, payload) {
      return new Promise((resolve) => {
        const params = {
          articelId: payload.materialId,
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentReadAdd
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentReadAdd
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 点赞接口
     * @param {*} context
     * @param {*} payload
     */
    contentLikeAdd (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.materialId,
          target_type: payload.targetType,
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentLikeAdd
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentLikeAdd
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 取消点赞接口
     * @param {*} context
     * @param {*} payload
     */
    contentLikeCancel (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.materialId,
          target_type: payload.targetType,
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentLikeCancel
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentLikeCancel
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 收藏接口
     * @param {*} context
     * @param {*} payload
     */
    contentFavoriteAdd (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.materialId,
          target_type: payload.targetType,
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentFavoriteAdd
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentFavoriteAdd
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 资讯中心新增接口 -- 取消收藏接口
     * @param {*} context
     * @param {*} payload
     */
    contentFavoriteCancel (context, payload) {
      return new Promise((resolve) => {
        const params = {
          target_id: payload.materialId,
          target_type: payload.targetType,
          sourceType: '1'
        }
        let url = ''
        if (process.env.NODE_ENV === 'development') {
          url = PROJECT_CONFIG.methods.contentFavoriteCancel
        } else {
          url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.contentFavoriteCancel
        }
        resolve(request(url, params, {
          method: 'get',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    /**
     * 服务号原有接口，用于资讯中心 -- 阅读数添加接口 -- jsonp
     * @param {*} context
     * @param {*} payload
     */
    addReadedMxpOther (context, payload) {
      return new Promise((resolve) => {
        if (!payload.appKey) {
          if (Vue.prototype.$baseUrl.indexOf('sit') > -1) {
            payload.appKey = PROJECT_CONFIG.base_appkey.base_appkey_test
          } else {
            payload.appKey = PROJECT_CONFIG.base_appkey.base_appkey_pro
          }
        }
        const params = {
          appKey: payload.appKey,
          articelId: payload.materialId,
          isThirdPartPlat: payload.isThirdPartPlat,
          userId: payload.isThirdPartPlat ? getUUID(32, 16) : '',
          userName: payload.isThirdPartPlat ? '匿名用户' : '',
          target_id: payload.materialId,
          sourceType: '1', // 1 - 素材中心文章， null or 0 - 服务号文章
          accessToken: payload.identification === 'admin' && payload.ssoToken
        }
        resolve(request(Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.addReadedMxpOther, params, {
          method: 'jsonp',
          identification: payload.identification,
          ssoToken: payload.ssoToken,
          appKey: payload.appKey
        }))
      })
    },
    // 获取资讯中心 list by tag
    //
    getmaterialListByTag (context, payload) {
      const params = payload
      const url = Vue.prototype.$baseUrl + PROJECT_CONFIG.methods.getmaterialListByTag
      return requestByMethod(url, params, {
        method: 'post',
        headers: { accessToken: payload.ssoToken }
      })
    },
    setArticle (context, payload) {
      context.commit('articleStatus', payload)
    },
    setArticleTitle (context, payload) {
      context.commit('articleTitleStatus', payload)
    },
    setUserId (context, payload) {
      context.commit('userIdStatus', payload)
    },
    setToken (context, payload) {
      context.commit('tokenStatus', payload)
    },
    setNoTokenFlag (context, payload) {
      context.commit('noTokenFlagStatus', payload)
    },
    setCommentNum (context, payload) {
      context.commit('commentNumberStatus', payload)
    },
    addCommentNum (context) {
      context.commit('increaseCommentNum')
    },
    setScrollTop (context, payload) {
      context.commit('scrollTopStatus', payload)
    },
    setContentWidth (context, payload) {
      context.commit('contentWidthStatus', payload)
    },
    setShowLoadingPic (context, payload) {
      context.commit('showLoadingPicStatus', payload)
    }
    // setScrollHeight (context, payload) {
    //   context.commit('scrollHeightStatus', payload)
    // }
  },
  modules: {
  }
})
